import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Dot } from '../common/Dot';
import Chip from '@mui/material/Chip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatusBadge(props) {
  var _props$append = props.append,
    append = _props$append === void 0 ? false : _props$append,
    label = props.label,
    _props$status = props.status,
    status = _props$status === void 0 ? 'default' : _props$status,
    sx = props.sx,
    _props$type = props.type,
    type = _props$type === void 0 ? 'badge' : _props$type;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(Box, {
    sx: _extends({}, sx),
    "data-element": "Box",
    "data-component": "StatusBadge",
    "data-source-file": "StatusBadge.tsx",
    children: [type === 'badge' && /*#__PURE__*/_jsx(Chip, {
      color: status === 'default' ? 'primary' : 'error',
      label: !isNaN(Number(label)) && Number(label) > 999 ? '999+' : label,
      sx: {
        height: '16px',
        padding: '0px 6px 0px 6px',
        position: 'absolute'
      },
      variant: "filled"
    }), type === 'dot' && /*#__PURE__*/_jsx(Box, {
      sx: {
        border: append ? '1px solid #FFFFFF' : '0px',
        borderRadius: '100px'
      },
      children: /*#__PURE__*/_jsx(Dot, {
        color: status === 'default' ? theme.palette.blue[700] : theme.palette.error[700]
      })
    })]
  });
}